var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",attrs:{"id":"app"}},[_c('a-layout-header',{staticStyle:{"background":"#fff","padding":"0"}},[(!_vm.$route.meta.hideHeader)?_c('div',{key:_vm.$route.fullPath},[_c('app-header')],1):_vm._e()]),_c(_vm.layout,{tag:"component"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }